import {gql} from 'apollo-boost';
import {TEACHER_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_VDOSETUNITS_BY_FILTER = gql`

  query getVdoSetUnitsByFilter($vdoSetUnitFilterInput: VdoSetUnitFilterInput){
    getVdoSetUnitsByFilter (
      vdoSetUnitFilterInput:$vdoSetUnitFilterInput
      # รับข้อมูลตามนี้จะใส่หรือไม่ใส่ก็ได้
      #  input VdoSetUnitFilterInput {
      #      vdoSetId: ID
      #      courseOutlineId: ID
      #      courseOutlineUnitId: ID
      #      teacherId: ID
      #      unitSeq: Int
      #      code: String
      #      status: String
      #  }
    ){
      id
      vdoSet{
        id
        subject{
          id code nameLocal nameEng
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }
      }
      unitSeq
      code
      totalVdoLength
      courseOutline{
        id
      }
      courseOutlineUnit{
        id
        seq
        nameLocal
        nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      status
      remark
      vdoSetTopics{
        id no nameLocal nameEng vdoStreamPath isEnabled
        playbackUrl
        playbackStatus
        videoProvider
        bunnyVideoGuid
        bunnyStatus
      }

    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_VDOSETUNITS = gql`
  query getVdoSetUnits {
    getVdoSetUnits {

      id
      vdoSet{
        id
        subject{
          id code nameLocal nameEng
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }
      }
      unitSeq
      code
      totalVdoLength
      courseOutline{
        id
      }
      courseOutlineUnit{
        id
        seq
        nameLocal
        nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      status
      remark
      vdoSetTopics{
        id no nameLocal nameEng vdoStreamPath isEnabled
        playbackUrl
        playbackStatus
        videoProvider
        bunnyVideoGuid
        bunnyStatus
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_VDOSETUNIT = gql`
  query getVdoSetUnit($id : ID!){
    getVdoSetUnit (
      id: $id
    ) {

      id
      vdoSet{
        id
        subject{
          id code nameLocal nameEng
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }
      }
      unitSeq
      code
      totalVdoLength
      courseOutline{
        id
      }
      courseOutlineUnit{
        id
        seq
        nameLocal
        nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      status
      remark
      vdoSetTopics{
        id no nameLocal nameEng vdoStreamPath isEnabled
        playbackUrl
        playbackStatus
        videoProvider
        bunnyVideoGuid
        bunnyStatus
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const ADD_VDOSETUNIT = gql`
  mutation addVdoSetUnit(
    $vdoSetId: ID!,
    $vdoSetUnitId: ID!,
    $courseOutlineId: ID!,
    $teacherId: ID!,
    $vdoSetUnitInput: VdoSetUnitInput!
  ) {
    addVdoSetUnit(
      vdoSetId: $vdoSetId
      vdoSetUnitId: $vdoSetUnitId
      courseOutlineId: $courseOutlineId
      teacherId: $teacherId
      vdoSetUnitInput: $vdoSetUnitInput
    ) {

      id
      vdoSet{
        id
        subject{
          id code nameLocal nameEng
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }
      }
      unitSeq
      code
      totalVdoLength
      courseOutline{
        id
      }
      courseOutlineUnit{
        id
        seq
        nameLocal
        nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      status
      remark
      vdoSetTopics{
        id no nameLocal nameEng vdoStreamPath isEnabled
        playbackUrl
        playbackStatus
        videoProvider
        bunnyVideoGuid
        bunnyStatus
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const UPDATE_VDOSETUNIT = gql`
  mutation updateVdoSetUnit(
    $id: ID!,
    $teacherId: ID!,
    $vdoSetUnitInput: VdoSetUnitInput!
  ) {
    updateVdoSetUnit(
      id: $id
      teacherId: $teacherId
      vdoSetUnitInput: $vdoSetUnitInput
    ) {

      id
      vdoSet{
        id
        subject{
          id code nameLocal nameEng
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }
      }
      unitSeq
      code
      totalVdoLength
      courseOutline{
        id
      }
      courseOutlineUnit{
        id
        seq
        nameLocal
        nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      status
      remark
      vdoSetTopics{
        id no nameLocal nameEng vdoStreamPath isEnabled
        playbackUrl
        playbackStatus
        videoProvider
        bunnyVideoGuid
        bunnyStatus
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const DELETE_VDOSETUNIT = gql`
  mutation deleteVdoSetUnit($id: ID!) {
    deleteVdoSetUnit(
      id: $id
    ) {

      id
      vdoSet{
        id
        subject{
          id code nameLocal nameEng
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }
      }
      unitSeq
      code
      totalVdoLength
      courseOutline{
        id
      }
      courseOutlineUnit{
        id
        seq
        nameLocal
        nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      status
      remark
      vdoSetTopics{
        id no nameLocal nameEng vdoStreamPath isEnabled
        playbackUrl
        playbackStatus
        videoProvider
        bunnyVideoGuid
        bunnyStatus
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

